import React, { createClass, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { amenitiesOptions } from '../../utils/select-fields';
import languagesObj from '../../localization/languages.json';
const languageSettings = languagesObj['en-US'];
import Card from '../tc-ui/card';
import getClassNames from 'classnames';
import Icon from '../tc-ui/icon';
import AddItemCard from './add-item-card';
import Select from 'react-select';
import { FlatButton } from 'material-ui';
import { connect } from 'react-redux';

const Amenities = createClass({

  propTypes: {
    routeName: PropTypes.string,
    editField: PropTypes.func,
    className: PropTypes.string,
    amenities: PropTypes.array,
    isEditable: PropTypes.bool,
  },

  getInitialState() {
    return {
      showResults: false,
      moreText: false,
      labelState: true,
    };
  },

  componentDidMount() {
    if (!this.refs.about) return;
    this.setShowAll();
  },

  setShowAll() {
    const aboutHeight = findDOMNode(this.refs.about).offsetHeight;
    if (aboutHeight > 126) {
      return this.setState({
        showResults: true,
        moreText: true,
        labelState: true,
      });
    }
    return this.setState({
      showResults: false,
      labelState: false,
    });
  },

  addClass(e) {
    e.preventDefault();
    this.setState({ showResults: !this.state.showResults,
                    moreText: !this.state.moreText });
  },

  _editAmenities() {
    const options = amenitiesOptions;
    this.props.inlineEditField('amenities', {
      isRequired: this.props.routeName === 'location' ? true : false,
      type: 'multi',
      options,
    });
  },

  render() {
    const classes = getClassNames('l-paper-right-info', this.props.className, {
      'short-info': this.state.showResults,
    });
    const { field, editMode, settings, value } = this.props;
    if (editMode) {
      return (
        <div className="location-data">
          <Card
            className="profile-card"
            title="Edit Amenities"
            subtitle=""
          >
            <Select
              multi
              placeholder="You can select more than one..."
              options={settings.options}
              name="amenities"
              onChange={options => this.props.sendEditToReducer({
                value: options ? options.map((option) => option.value) : [],
              })}
              layout={"l-paper-right multi-select"}
              value={value}
              scrollMenuIntoView={false}
              clearable={false}
            />
            <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
              <FlatButton
                style={{ marginRight: '8px' }}
                label="Cancel"
                type="button"
                primary
                disableTouchRipple
                disableFocusRipple
                onClick={this.props.clearEditState}
              />
              <FlatButton
                style={{ marginRight: '8px' }}
                label="Save"
                type="button"
                secondary
                disableTouchRipple
                disableFocusRipple
                onClick={() => {
                  const options = {
                    updateField: field,
                    updateBody: value,
                  };
                  return this.props._saveField(options);
                }}
              />
            </div>
          </Card>
        </div>
      );
    }
    const label = this.state.moreText ? languageSettings.company.more : null;
    const more = this.state.labelState ? label : null;
    let gradient;

    if (this.state.moreText) gradient = <div className="cardGradient" />;

    let amenitiesList;
    let addAmenitiesText;
    let titleBarExtra;
    if (Array.isArray(this.props.amenities) && this.props.amenities.length) {
      amenitiesList = this.props.amenities.map((amenity, index) => <div className="amenity" key={index}> {amenity} </div>);

      if (this.props.isEditable) {
        titleBarExtra = (
          <div className="profile-edit" onClick={this._editAmenities}>
            <Icon className="tc-icon-mode_edit profile-edit-icon"/>
            &nbsp;EDIT
           </div>
        );
      }
    } else if (this.props.isEditable) {
      gradient = null;
      addAmenitiesText = (
        <AddItemCard onClick={this._editAmenities} text ="Add Amenities"/>
      );
    }

    return (
      <div className="location-data" id="amenity">
        {addAmenitiesText ? addAmenitiesText : (
          <Card
            className="profile-card"
            title={languageSettings.company.amenities.title}
            companyData="companyData"
            subtitle=""
            titleBarExtra={titleBarExtra}
          >
            <div className={classes} ref="about">
              {amenitiesList}
              {addAmenitiesText}
            </div>
            {gradient}
            <a href="#" className="load-more" onClick={this.addClass}> {more} </a>
          </Card>
        )}
      </div>
    );
  },
});

const mapStateToProps = ({ editFieldModal }) => ({
  field: editFieldModal.get('field'),
  editMode: editFieldModal.get('field') === 'amenities',
  value: editFieldModal.toJS().value || [],
  settings: editFieldModal.toJS().settings || [],
});

export default connect(mapStateToProps)(Amenities);



// WEBPACK FOOTER //
// ./src/app/components/profile/amenities.jsx